/* eslint-disable max-statements */
import { TemplateType } from 'aws-sdk/clients/iot';
import React, { useEffect, useState } from 'react';
import { BsCheck2Circle } from 'react-icons/bs';
// import placeholder from '../../../assets/images/placeholder.png';
import { useNavigate } from 'react-router-dom';
import { Tag } from '../../../Utils/Components/tag';
import { useMutation, useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { axiosInstance } from '../../../../config/axiosInstance';
import { globalEnv } from '../../../../config/baseConfig';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../Utils/notification';
import { StartButton } from '../../../Utils/saveButton';
import LoadingAnimComponent from '../../../Utils/LoadingAnimations/loadingAnimation';
import axios from 'axios';
import { setTab } from '../../../../redux/actions/sideBarAction';

export const SelectTemplate = () => {
	const [campaignName, setCampaignName] = useState<string>();
	const [selectedTemplates, setSelectedTemplates] = useState<string[]>([]);
	const [tags, setTags] = useState<string[]>([]);
	const [isChanged, setIsChanged] = useState(false);
	const [isSaving, setIsSaving] = useState(false);

	const [emailTemplates, setEmailTemplates] = useState<EmailTemplateType[]>([]);

	type EmailTemplateType = {
		_id: number;
		name: string;
		pictureUrl: string;
	};

	function addTag() {
		setTags([...tags, '']);
	}

	const navigate = useNavigate();

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	async function fetchSettingsData() {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/outreach/email-template/all`,
			config
		);
		return data;
	}

	const { data, isLoading, isError } = useQuery([], () => fetchSettingsData(), {
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		staleTime: 5000
	});

	useEffect(() => {
		if (data != null) {
			setEmailTemplates(data);
		}
	}, [data]);

	const startSendingReq = async () => {
		const dto = {
			name: campaignName
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance.post(
			globalEnv.BASE_URL + '/outreach/campaign',
			dto,
			config
		);
		return response;
	};

	const dispatch = useDispatch();
	dispatch(setTab('outreach'));

	const startSending = useMutation(startSendingReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: (data) => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Campaign created'
				})
			);
			console.log(data);
			console.log(data._id);
			navigate(
				`../outreach/campaign/${
					data._id
				}/${selectedTemplates.join()}/send-email`
			);
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't create campaign"
				})
			);
		}
	});

	return (
		<div className="pt-16 pl-18 dark:bg-gray-800">
			<div className="w-full mt-2 pr-3 px-3">
				<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">
					Compaign name
				</label>
				<input
					className="inputStyle"
					id="grid-last-name"
					type="text"
					placeholder="Write the name here"
					onChange={(e) => {
						setCampaignName(e.target.value);
					}}
					value={campaignName}
				/>
			</div>

			<div
				className="flex flex-row w-full lg:w-10/12 md:w-11/12 mt-5 mb-7 justify-start
												  sm:px-2 md:px-10 lg:px-6 lg:mt-3"
			>
				<div>
					<h3 className="font-bold mb-2 text-sm lg:text-base dark:text-gray-100">
						Keywords
					</h3>
					<div className="flex flex-row space-x-2">
						{tags != null &&
							tags.map((tag, index) => (
								<Tag
									name={tag}
									isMine={true}
									setIsChanged={setIsChanged}
									index={index}
									setTags={setTags}
									tags={tags}
								/>
							))}

						{tags != null ? (
							tags.length > 0 ? (
								<div
									className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
								>
									<span className="text-xs font-bold mx-1" onClick={addTag}>
										➕
									</span>
								</div>
							) : (
								<div className="inline-block">
									<span className="text-xs font-bold mx-1 text-gray-400">
										Campaign has no keywords
									</span>
									<div
										className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
									>
										<span className="text-xs font-bold mx-1" onClick={addTag}>
											Add first keyword ➕
										</span>
									</div>
								</div>
							)
						) : (
							<div className="inline-block">
								<span className="text-xs font-bold mx-1 text-gray-400">
									Campaign has no keywords
								</span>
								<div
									className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
								>
									<span className="text-xs font-bold mx-1" onClick={addTag}>
										Add first keyword➕
									</span>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
			{isLoading ? (
				<LoadingAnimComponent />
			) : (
				<>
					<div className="mt-5 w-full flex justify-center">
						<h3 className="block uppercase text-6xl tracking-wide text-gray-700 dark:text-gray-300 font-bold mb-2 px-3">
							Pick a template
						</h3>
					</div>
					<div className="mx-auto mt-5 pr-3">
						<div className="w-11/12 lg:w-fit carousel p-4 bg-card-light border-border-light dark:bg-gray-700 dark:border-border-dark rounded-box mx-auto transition-all duration-500">
							<>
								{emailTemplates.length > 0 &&
									emailTemplates.map((item: any, index: number) => (
										<TemplateCard
											id={item._id}
											title={item.name}
											path={item.path}
											img={item.pictureUrl}
											index={index}
											isSelected={selectedTemplates.includes(item.path)}
											selectedTemplates={selectedTemplates}
											setSelectedTemplates={setSelectedTemplates}
										/>
									))}
							</>
						</div>
					</div>
				</>
			)}
			<div className="w-full flex justify-end mt-3 pr-3">
				<StartButton
					text="Create campaign"
					isSaving={isSaving}
					saveFunc={() => startSending.mutate()}
				/>
			</div>

			<div className="h-3"></div>
		</div>
	);
};

export type templateCardType = {
	id: number;
	title: string;
	path: string;
	img: string;
	index: number;
	isSelected: boolean;
	selectedTemplates: string[];
	setSelectedTemplates: (templates: string[]) => void;
};

export function TemplateCard(props: templateCardType) {
	const addTemplate = () => {
		const templatesCopy = props.selectedTemplates.slice();
		templatesCopy.push(props.path);
		props.setSelectedTemplates(templatesCopy);
	};

	const removeTemplate = () => {
		const templatesCopy = props.selectedTemplates.slice();
		templatesCopy.splice(
			templatesCopy.findIndex((item) => item === props.path),
			1
		);
		props.setSelectedTemplates(templatesCopy);
	};

	return (
		<div className="carousel-item flex flex-col transition-all duration-700 h-3/5">
			<div
				className={`relative mx-3 overflow-hidden shadow-xl rounded-2xl max-w-xl `}
			>
				<img
					src={props.img}
					className={`object-cover h-[450px] w-64 rounded-2xl  ${
						props.isSelected && 'border-purple-600 border-4'
					}`}
				/>

				<div
					className="absolute inset-0 bg-gradient-to-t from-black/50 opacity-0 hover:opacity-100 transition-all duration-500 text-center  cursor-pointer"
					onClick={() => {
						props.isSelected ? removeTemplate() : addTemplate();
					}}
				/>

				{props.isSelected ? (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-purple-600  dark:text-primary text-center transition-all duration-500 opacity-100"
					/>
				) : (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-purple-600  mx-2 dark:text-primary text-center transition-all duration-500 opacity-0 scale-0"
					/>
				)}
			</div>

			<h3 className="text-gray-600 dark:text-gray-200 text-lg mt-2 font-semibold mx-auto">
				{props.title}
			</h3>
		</div>
	);
}
